import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import * as constants from 'Constants';
import PhotoMediaStore from 'stores/Model/PhotoMediaStore';
import ScreenshotStore from './ScreenshotStore';
import LinkStore from './LinkStore';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';



class ListingStore {

  @setter @observable logoMedia;
  @setter @observable tagline;
  @setter @observable desc;
  @setter @observable categoryOptionId;

  @setter @observable integratedApps;
  @setter @observable screenshots;
  @setter @observable links;

  static create(data={}) {
    const instance = new ListingStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "logoMedia": new PhotoMediaStore(),
      "tagline": "",
      "desc": "",
      "categoryOptionId": "",

      "integratedApps": [],
      "screenshots": [],
      "links": [],
    };
  }

  constructor(defaults=ListingStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=ListingStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "logoMedia", "accessor": "logo_media", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": PhotoMediaStore},
      {"field": "tagline"},
      {"field": "desc", "accessor": "desc"},
      {"field": "categoryOptionId", "accessor": "category_option_id"},

      {"field": "integratedApps", "accessor": "integrated_apps"},
      {"field": "screenshots", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": ScreenshotStore},
      {"field": "links", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": LinkStore},
    ];
  }

  @action deserialize(data) {
    deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }
}



export default ListingStore;

